import './AppStorePage.css';

const AppStorePage = () => {
  return (
    <div className="app-store-page">
      {/* Hero Section */}
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">Get the ReadTheWord app</h1>
          <p className="hero-subtitle">Download our mobile app to read the Bible on the go</p>
        </div>
      </div>

      {/* Download Section */}
      <div className="download-section">
        <div className="download-content">
          <h2>Available on mobile</h2>
          <p className="download-description">
            Experience ReadTheWord on your mobile device with our native apps for iOS and Android.
          </p>

          <div className="store-buttons">
            {/* Apple App Store */}
            <a 
              href="https://apps.apple.com/us/app/readtheword-app/id6753018920" 
              target="_blank" 
              rel="noopener noreferrer"
              className="store-button ios-button"
            >
              <div className="store-button-content">
                <div className="store-icon">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                  </svg>
                </div>
                <div className="store-text">
                  <div className="store-line-1">Download on the</div>
                  <div className="store-line-2">App Store</div>
                </div>
              </div>
            </a>

            {/* Google Play Store - Coming Soon */}
            <div className="store-button android-button coming-soon">
              <div className="store-button-content">
                <div className="store-icon">
                  <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                  </svg>
                </div>
                <div className="store-text">
                  <div className="store-line-1">Coming soon to</div>
                  <div className="store-line-2">Google Play</div>
                </div>
              </div>
              <div className="coming-soon-overlay">
                <span>Coming soon</span>
              </div>
            </div>
          </div>

          {/* Features Section */}
          <div className="features-section">
            <h3>What you'll get:</h3>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">📱</div>
                <h4>Mobile reading</h4>
                <p>Read the Bible anywhere with our optimized mobile interface</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🎵</div>
                <h4>Audio support</h4>
                <p>Listen to professional Bible narration while reading</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🏆</div>
                <h4>Streaks</h4>
                <p>Keep a reading streak and see your journey</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">👨‍👩‍👧‍👦</div>
                <h4>Family features</h4>
                <p>Create readers for family members and track progress together</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📊</div>
                <h4>Progress tracking</h4>
                <p>Track chapters and see your reading journey</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔔</div>
                <h4>Smart reminders</h4>
                <p>Personalized notifications to keep you on track</p>
              </div>
            </div>
          </div>

          {/* Web App CTA */}
          <div className="web-cta-section">
            <h3>Or continue with the web app</h3>
            <p>Already here? Start reading right in your browser!</p>
            <a href="/" className="web-cta-button">
              Continue on the web
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppStorePage;
